// extracted by mini-css-extract-plugin
export default {"lastEdit":"UserTable_lastEdit__N8ydW","thead":"UserTable_thead__3-ZRJ","customBtn":"UserTable_customBtn__F7Gnf","table":"UserTable_table__nMXmT"};